import { Box, Grid, Collapse, Card } from "@mui/material";
import ActiveFilters from "../../../../../Components/filters/ActiveFilters";
import FilterItems from "./FilterItems";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
  bays,
  categories,
  groups,
}) => {
  // Find bay name by code
  const getBayName = (bayCode) => {
    if (!bayCode) return "";
    const bay = bays.find((b) => b.bay_code === bayCode);
    return bay ? bay.bay_code : bayCode;
  };

  // Find category name by code
  const getCategoryName = (categoryCode) => {
    if (!categoryCode) return "";
    const category = categories.find((c) => c.category_code === categoryCode);
    return category
      ? `${category.category_code} - ${category.category_name}`
      : categoryCode;
  };

  const activeFilterDefinitions = [
    {
      type: "standard",
      id: "bay_code",
      label: "Bays",
      value: Array.isArray(submittedData.bay_code)
        ? submittedData.bay_code.map(getBayName).join(", ")
        : "",
    },
    {
      type: "dateRange",
      id: "date",
      label: "Date Range",
      startValue: submittedData.start_date,
      endValue: submittedData.end_date,
      startField: "start_date",
      endField: "end_date",
    },
    {
      type: "standard",
      id: "group_by",
      label: "Group By",
      value: submittedData.group_by
        ? groups.find((g) => g.group_code === submittedData.group_by)
            ?.group_name || submittedData.group_by
        : "",
    },
    {
      type: "standard",
      id: "category_code",
      label: "Categories",
      value: Array.isArray(submittedData.category_code)
        ? submittedData.category_code.map(getCategoryName).join(", ")
        : "",
    },
  ];

  const handleRemoveDateRange = (field) => {
    handleRemove(field);
  };

  return (
    <Grid item xs={12} sx={{ mb: 2 }}>
      <Collapse in={filterOpen}>
        <Card>
          <Box p={4}>
            <FilterItems
              filterData={filterData}
              handleChangeFilter={handleChangeFilter}
              handleFilter={handleFilter}
              handleClearFilters={handleClearFilters}
              bays={bays}
              categories={categories}
              groups={groups}
            />
          </Box>
        </Card>
      </Collapse>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveDateRange={handleRemoveDateRange}
        onRemoveFilter={handleRemove}
      />
    </Grid>
  );
};

export default Filter;
